import { FormattedMessage } from "react-intl";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Avatar, Badge, Box, Button, Grid, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Banner from "../../../assets/img/bg/UserDetails.png";
import DirectMessageButton from "../../UserDetails/AccountSettingsModal/BannerSection/DirectMessageButton";
import AddressRow from "./AddressRow";
import BioDescriptionRow from "./BioDescriptionRow";
import EmploymentRow from "./EmploymentRow";
import NameRow from "./NameRow";

const useStyles = makeStyles(theme => ({
  userAvatar: {
    width: 150,
    height: 150,
    borderWidth: 7,
    borderColor: "#fff",
    borderStyle: "solid",
  },
  badgedAvatar: {
    position: "absolute",
    left: 30,
    top: 40,
  },
  viewAs: {
    position: "absolute",
    top: 0,
    right: 0,
    backgroundColor: "rgba(255, 255, 255, 0.35)",
    border: "1px solid #00000059",
    borderRadius: "4px",
    margin: "18px",
    padding: "12px",
  },
  mainContent: {
    marginTop: 20,
    paddingLeft: 200,
    [theme.breakpoints.down("sm")]: {
      padding: "12px 18px",
      marginTop: 40,
    },
  },
}));

const MainContentReadOnly = ({
  onClosePreview,
  onDirectMessageRequest,
  userDetails,
}) => {
  const classes = useStyles();

  const {
    avatarUrl,
  } = userDetails;

  return (
    <Box flex={1} style={{ position: "relative" }}>
      <Box flex={1} style={{ height: 130, background: `url(${Banner})`, position: "relative" }}>
        <Badge
          overlap="circle"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          className={classes.badgedAvatar}
        >
          <Avatar
            className={classes.userAvatar}
            src={avatarUrl}
          />
        </Badge>
        <Box
          component="div"
          sx={{
            display: "flex",
            flexdirection: "row",
            height: "100%",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <DirectMessageButton onClick={onDirectMessageRequest} />
        </Box>
      </Box>
      <Box flex={1} style={{ minHeight: 100 }}>
        <Grid container alignItems="center" className={classes.mainContent}>
          <Grid item sm={12} md={6} style={{ flexGrow: 1 }}>
            <NameRow userDetails={userDetails} />
            <EmploymentRow userDetails={userDetails} />
            <AddressRow userDetails={userDetails} />
          </Grid>
          <Grid item xs={11}>
            <BioDescriptionRow userDetails={userDetails} />
          </Grid>
        </Grid>

        {!!onClosePreview && (
          <div className={classes.viewAs}>
            <Tooltip
              arrow
              placement="left"
              title={<FormattedMessage id="tooltip.preview.end" />}
            >
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                size="small"
                onClick={onClosePreview}
              >
                <VisibilityOffIcon />
              </Button>
            </Tooltip>
          </div>
        )}

      </Box>
    </Box>
  );
};

export default MainContentReadOnly;
